import styled from 'styled-components';

export const Block = styled.div`
  padding: 0.7rem 1rem;
  background-color: white;
  border-radius: 16px;
  width: 100%;
  font-size: 1.1rem;
  text-align: center;
  // color: #FFF;
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(197, 207, 215, 0.2);
`;

export const BlockTitleArea = styled.div`
  display: grid;
  grid-template-columns: 30px 2fr 0.5fr;
  grid-template-rows: auto;
  width: 100%;
  padding-bottom: 1rem;
  justify-content: center;
  align-items: center;
  grid-gap: 1rem;
  gap: 1rem;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  background-color: ${(props) => props.color};
  padding: 5px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.color ? props.color : 'transparent')};
  border-radius: 8px;
  padding: 3px 8px;
  text-transform: uppercase;
`;
